import React, { Component } from 'react'
import styled from 'styled-components'
import { Flex } from 'rebass'
import ReactResponsiveSelect from '../VehicleHeroFilterBar/components/react-responsive-select/src/ReactResponsiveSelect'
import {
  ResponsiveSelectFlex,
  Arrow
} from './components/ResponsiveSelectStyled'

const FiltersWrapper = styled(Flex)`
  background-color: white;
  border-bottom: 1px solid ${(props) => props.theme.colors.blue};
  flex-wrap: wrap;
`

class FullReviewFilters extends Component {
  constructor(props) {
    super(props)
    this.state = {
      dealerships: this.getDealerships()
    }
    this.getDealershipSelectOptions = this.getDealershipSelectOptions.bind(this)
  }

  getDealerships() {
    return [
      {
        text: 'Top Rated',
        value: 'top'
      },
      {
        text: 'Latest',
        value: 'latest'
      }
    ]
  }

  getDealershipSelectOptions() {
    return this.state.dealerships.map((type) => {
      let markup =
        type.value === 'default' ? (
          <div />
        ) : (
          this.multiSelectOptionMarkup(type.text)
        )
      return {
        text: type.text,
        value: type.value,
        markup: markup
      }
    })
  }

  multiSelectOptionMarkup(text) {
    return (
      <div className="rrs__option_padding">
        <span>{text}</span>
      </div>
    )
  }

  render() {
    return (
      <FiltersWrapper>
        <ResponsiveSelectFlex>
          <ReactResponsiveSelect
            name="filter"
            selectedValue={this.props.filterValue}
            onChange={this.props.filter}
            options={this.getDealershipSelectOptions()}
            caretIcon={<Arrow open />}
          />
        </ResponsiveSelectFlex>
      </FiltersWrapper>
    )
  }
}

export default FullReviewFilters
